import axios from "axios";
import { Title } from "chart.js";
import Swal from "sweetalert2";
const baseURL = process.env.REACT_APP_baseUrl;

export const AxiosInstance = axios.create({
    baseURL: baseURL,
})

AxiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            handleSessionExpired();
        }
        return Promise.reject(error);
    }
);

const handleSessionExpired = () => {
    Swal.fire({
        title: "Session Expired",
        text: "Your session has expired. Please login again.",
        icon: "warning",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
            popup: "custom-swal-popup",
            title: "custom-swal-title",
            htmlContainer: "custom-swal-text",
            confirmButton: "custom-swal-confirm",
            cancelButton: "custom-swal-cancel",
        },

        buttonsStyling: false,
    }).then((result) => {

        if (result.isConfirmed) {
            localStorage.removeItem("userAuthToken");
            localStorage.removeItem("userProfileData");
            localStorage.removeItem("userLoggedIn");

            window.location.href = "/";
        }
    });
};
